<app-loading-animation *ngIf="loadingService.loading$ | async"></app-loading-animation>
<router-outlet></router-outlet>
<!-- <wl-footer></wl-footer> -->